import { DEFAULT_GETTERS } from '@/modules/b2b/constants';

export default {
  ...DEFAULT_GETTERS,
  list: (state) => state.list,
  totalCount: (state) => state.totalCount,
  params: (state) => state.params,
  detailPurchase: (state) => state.detailPurchase?.list,
  customerAndStatus: (state) => state.customerAndStatus?.list,
  itemDisputes: (state) => state.itemDisputes?.list,
  invoiceList: (state) => state.invoiceList?.list,
  sendInvoiceToPeppolByOrderId: (state) => state.sendInvoiceToPeppolByOrderId,
  item: (state) => state.item,
  isLoadMore: (state) => state.isLoadMore,
  customerPeppol: (state) => state.customerPeppol,
  tenantIntegrationStorecove: (state) => state.tenantIntegrationStorecove,
  viewPrice: (state) => state.viewPrice,
  itemAmendments: (state) => state.itemAmendments,
  list_customer_b2b: (state) => state.list_customer_b2b,
  totalCountCompany: (state) => state.totalCountCompany,
  isRepeatOrderSuccess: (state) => state.isRepeatOrderSuccess,
  unAvailableRepeatSkuIds: (state) => state.unAvailableRepeatSkuIds,
  isEnableSoftBlockOrder: (state) => state.isEnableSoftBlockOrder
};
